// eslint-disable-next-line import/no-named-as-default-member
import ScaleLevel from './scale-level.entity';

export default class Quadrant {
  public id: string;

  public label: string;

  public description: string;

  public hexColor: string;

  public hexTextColor: string;

  public xAxisLevel: ScaleLevel;

  public yAxisLevel: ScaleLevel;

  constructor(obj: any = {}) {
    this.id = obj.id;
    this.label = obj.label || '';
    this.description = obj.description || '';
    this.hexColor = obj.hexColor || '';
    this.hexTextColor = obj.hexTextColor || '';
    this.xAxisLevel = new ScaleLevel(obj.xAxisLevel || {});
    this.yAxisLevel = new ScaleLevel(obj.yAxisLevel || {});
  }
}
